module.exports = __webpack_public_path__ + "img/cm-logo.5073e587.png";